import { Button } from "@wojo/ui";
import { useI18n } from "@wojo/localization";

export type EmailTravelersButtonProps = {
    emails: string[];
    allEmails: string[];
    buttonText?: string;
};

export const EmailTravelersButton: React.FC<EmailTravelersButtonProps> = ({
    emails,
    allEmails,
    buttonText,
}) => {
    const i18n = useI18n("account").account.myGroupMembers.bookedTravelers;
    const mailtoLink =
        emails.length === 0
            ? `mailto:${allEmails.join(",")}`
            : `mailto:${emails.join(",")}`;
    let text =
        emails.length === 0
            ? i18n.emailAllTravelers.l()
            : i18n.emailSelectedTravelers.l();

    if (buttonText) {
        text = buttonText;
    }

    return (
        <Button
            tag="button"
            onClick={() => window.open(mailtoLink)}
            variant={"secondary"}
        >
            {text}
        </Button>
    );
};
